/**
 * Sample form data for auto-fill on Meeting create page.
 * Fills meetingDate, title, summary, and sample action items — attendees must be selected by user.
 */
export type MeetingFormSample = {
  meetingDate: string;
  title: string;
  summary?: string;
  actions: { description: string; dueDate?: string }[];
};

export const meetingFormSamples: MeetingFormSample[] = [
  {
    meetingDate: new Date().toISOString().slice(0, 10),
    title: "ປະຊຸມສາມາດປະຈໍາເດືອນ",
    summary:
      "ປະຊຸມສາມາດປະຈໍາເດືອນ ປຶກສາຫາລືຜົນການເຮັດວຽກ ແລະ ແຜນວຽກເດືອນຖັດໄປ.",
    actions: [
      {
        description: "ສະຫຼຸບຜົນການເຮັດວຽກເດືອນຜ່ານມາ",
        dueDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
          .toISOString()
          .slice(0, 10),
      },
      {
        description: "ກວດສອບແຜນວຽກເດືອນຖັດໄປ",
        dueDate: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000)
          .toISOString()
          .slice(0, 10),
      },
    ],
  },
  {
    meetingDate: new Date().toISOString().slice(0, 10),
    title: "ປະຊຸມປະຈໍາອາທິດ",
    summary: "ປະຊຸມປະຈໍາອາທິດ ຕິດຕາມຄວາມຄືບໜ້າຂອງໂຄງການ.",
    actions: [
      {
        description: "ສົ່ງລາຍງານຄວາມຄືບໜ້າໃຫ້ຜູ້ຈັດການ",
        dueDate: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000)
          .toISOString()
          .slice(0, 10),
      },
    ],
  },
  {
    meetingDate: new Date().toISOString().slice(0, 10),
    title: "ປະຊຸມສັງຫາ (Ad-hoc)",
    summary: "ປະຊຸມສັງຫາເພື່ອປຶກສາຫາລືເລື່ອງດ່ວນ.",
    actions: [
      {
        description: "ດຳເນີນການຕາມຂໍ້ຕົກລົງ",
      },
    ],
  },
  {
    meetingDate: new Date().toISOString().slice(0, 10),
    title: "ປະຊຸມກອງປະຊຸມໃຫຍ່ປະຈໍາປີ",
    summary:
      "ປະຊຸມກອງປະຊຸມໃຫຍ່ປະຈໍາປີ ພິຈາລະນາຜົນງານປີຜ່ານມາ ແລະ ແຜນຍຸດທະສາດປີໃໝ່.",
    actions: [
      {
        description: "ກະກຽມສະຫຼຸບຜົນງານປີ",
        dueDate: new Date(new Date().getFullYear(), 11, 31).toISOString().slice(0, 10),
      },
      {
        description: "ນຳສົ່ງແຜນຍຸດທະສາດປີໃໝ່",
        dueDate: new Date(new Date().getFullYear() + 1, 0, 15).toISOString().slice(0, 10),
      },
    ],
  },
];
